<template>
    <div>
      <form id="contatoForm" @submit.prevent="submit" class="ajax_off">
        <div class="form-group">
          <label>Nome</label>
          <input type="text" name="nome" class="form-control" v-model="contato.nome" placeholder="Digite o nome" />
        </div>
        <div class="form-group">
          <label>E-mail</label>
          <input type="email" name="email" class="form-control" v-model="contato.email" placeholder="Digite o e-mail" />
        </div>

        <div class="form-group">
            <label>Frequência das notificações:</label>
            <select class="form-control" v-model="contato.frequencia" name="notificar_email_quando">
                <option value="0">Nunca</option>
                <option value="7">Semanalmente</option>
                <option value="15">Quinzenalmente</option>
                <option value="30">Mensalmente</option>
                <option value="60">Bimestralmente</option>
                <option value="90">trimestralmente</option>
            </select>
        </div>
      </form>
    </div>
  </template>

  <script>

import {mapState} from 'vuex';
  export default {
    props: {
      id: Number,
      processo_id: Number,
    },
    data() {
      return {
        contato: {
          nome: null,
          email: null,
          whatsapp: null,
          frequencia: 15,
        },
      };
    },
    computed:{
      ...mapState('user', [
        'parceiro'
      ])
    },
    methods: {

      async submit() {
        this.contato.processo_id = this.processo_id;
        if (this.id) {
          await this.$api.put(`processo-contact/${this.id}`, this.contato);
        } else {
          await this.$api.post("processo-contact", this.contato);
        }

        this.$emit('addContact');
        this.$bvModal.hide("addContatoModal");
      },
    },
  };
  </script>
